import React from 'react';
import Animator from './Animator.js';


class FreeText extends Animator {

  constructor(props) {
    super(props);
    this.state = {
      active: false,
      data  : undefined,
      overlayConfig: this.props.display.state.overlays!==undefined&&this.props.display.state.overlays[this.props.overlayConf]!==undefined?this.props.display.state.overlays[this.props.overlayConf].overlay:{},
      transition : "transition-start" ,
      idx:0,
    };
  }

  onSetTimeout(){
  }

  onInit(overlayConfig){
    this.animate(false,overlayConfig);
  }

  onData (data,key) {
    if( data.visible ) {
      var tmp = data.text.split("\n");
      data.token = tmp;
      this.setState({active: data.visible,idx:0, data:data});
      if (tmp.length > 0 ) {
        clearInterval(this.interval);
        clearInterval(this.offTimer);
        this.interval = setInterval(() => this.next(), (100));
      }
    } else {
      clearInterval(this.interval);
      clearInterval(this.offTimer);
      super.animate(false,this.state.overlayConfig);
    }
  }

  nextLayer()  {

    if( this.state.data !== undefined && this.state.data.token!== undefined ) {
        if(this.state.data.token.length > (this.state.idx+1)) {
          this.setState({idx: this.state.idx + 1},()=>{
            this.interval = setInterval(() => this.next(), (2 * 1000));
          });
        } else {
          this.setState({idx: 0},()=>{
            this.interval = setInterval(() => this.next(), (2 * 1000));
          });
        }
    }
  }

  next() {
      clearInterval(this.interval);
      if( this.state.data !== undefined && this.state.data.token!== undefined ) {

          super.animate(true,this.state.overlayConfig, ()=>{
            this.offTimer = setInterval(() => {
              clearInterval(this.offTimer);
              super.animate(false,this.state.overlayConfig,()=>{
                  this.nextLayer();
              });
             } , (8 * 1000));

          });
      }
  }

  componentDidMount() {
    this.props.display.registDataListener(this.props.stateName,this);
  }

  render() {
    if(this.state.data === undefined || this.state.overlayConfig === undefined || this.state.overlayConfig.elements === undefined) {
      return (<div className={this.state.transition}/>);
    }
    const text = this.state.overlayConfig.elements.text.element;

    return (
        <div className={this.props.stateName} style={{position : "absolute",top:'0px',left:'0px',width:'100%', height:'100%'}}>
          <div style={{
            position : "absolute",
            left :text.x+"px",
            top : text.y+"px",
            width :text.width+"px",
            height :text.height+"px",
            display: "flex",
            alignItems: text.valign,
            justifyContent: text.align,
          }}> <span style={{color:"#fff", textShadow: "#000 0px 0px 2px",WebFontSmoothing: "antialiased", lineHeight:"1",color :text.fontColor, fontFamily : text.font, fontSize : text.fontSize + "px"}}>{this.state.data.token[this.state.idx]}</span> </div>
        </div>
    );
  }
}
export default FreeText;
